import { SUBSCRIBE_CHANNEL } from '../constants';
import createEntityLocalizer from '../utils/createEntityLocalizer';

interface LocalizedPercentProps {
    percent: number;
    options?: {
        precision?: number;
        showPositiveSign?: boolean;
        multiplier?: number;
    };
}

export const createLocalizedPercent = ({
    subscribeChannelKey = SUBSCRIBE_CHANNEL,
    handlerKey = 'localizePercent',
} = {}) =>
    createEntityLocalizer<LocalizedPercentProps>({
        subscribeChannelKey,
        handlerKey,
        displayName: 'LocalizedPercent',
        entityName: 'percent',
    });

export default createLocalizedPercent();
